import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectRole } from "./infoSlice";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { useMemo } from "react";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";
import TrackContainer from "./TrackContainer";

const FeatureTrack = ({ history }) => {
  const { t } = useTranslation();
  const role = useSelector(selectRole);
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const featuresOptions = useMemo(() => {
    switch (role) {
      case "Partner":
      case "Kid":
      case "Friend":
      case "Sibling":
      case "Grandparent":
      default:
        return [
          {
            id: 0,
            imgPath: ('../assets/which_features/real_time_location_tracking.png'),
            name: t("real_time_tracking"),
            value: "RealtimeTracking"
          },
          {
            id: 1,
            imgPath: ('../assets/which_features/place_alerts.png'),
            name: t("place-alerts"),
            value: "PlaceAlerts"
          },
          {
            id: 2,
            imgPath: ('../assets/which_features/check_in.png'),
            name: t("check-in"),
            value: "CheckIn"
          },
          {
            id: 3,
            imgPath: ('../assets/which_features/location_history.png'),
            name: t("location-history"),
            value: "LocationHistory"
          },
          {
            id: 4,
            imgPath: ('../assets/which_features/panic_button.png'),
            name: t("panic-button"),
            value: "PanicButton"
          },
          {
            id: 5,
            imgPath: ('../assets/which_features/all_the_above.png'),
            name: t("all_the_above"),
            value: "All"
          },
          {
            id: 6,
            imgPath: ('../assets/which_features/other.png'),
            name: t("other"),
            value: "Other"
          },
        ];
    }
    
  }, [t, role]);

  const onContinueClick = (features) => {
    dispatch(setEventData({ id: "Features", data: features }));
    sendAnalyticsEvents(EVENTS.onboardingFeatureListSubmitted, {
      ...eventsData,
      Features: features,
    });
    history.push("/explore-solutions");
  };
  
  return (
    <TrackContainer
      pageEvent={"onboardingFeatureListShown"}
      title={
        role === "Other"
          ? t("question8_other")
          : t("question8_title", { role: role.toLowerCase() })
      }
      multiple
      options={featuresOptions}
      onContinueClick={onContinueClick}
      nextPage={'explore-solutions'}
    />
  );
}

export default FeatureTrack;